// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fixed-return-button {
    position: fixed;
    bottom: 30px;
    right: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--primary-blue);
    color: white;
    padding: 8px 10px;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    transition: all 0.3s ease, border-radius 0.3s ease;
    z-index: 99;
}

.return-icon {
    font-size: 1rem;
    color: white;
}

.return-text-hover {
    white-space: nowrap;
    opacity: 0;
    max-width: 0;
    transition: all 0.3s ease;
    font-weight: 200;
    font-size: 1.1rem;
    overflow: hidden;
}

.fixed-return-button:hover {
    border-radius: 50px;
    padding: 8px 25px;
    background-color: var(--primary-blue);
    gap: 10px;
}

.fixed-return-button:hover .return-text-hover {
    opacity: 1;
    max-width: 200px;
}`, "",{"version":3,"sources":["webpack://./src/components/BackButton/backButton.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,yCAAyC;IACzC,kDAAkD;IAClD,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB","sourcesContent":[".fixed-return-button {\r\n    position: fixed;\r\n    bottom: 30px;\r\n    right: 30px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: var(--primary-blue);\r\n    color: white;\r\n    padding: 8px 10px;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\r\n    transition: all 0.3s ease, border-radius 0.3s ease;\r\n    z-index: 99;\r\n}\r\n\r\n.return-icon {\r\n    font-size: 1rem;\r\n    color: white;\r\n}\r\n\r\n.return-text-hover {\r\n    white-space: nowrap;\r\n    opacity: 0;\r\n    max-width: 0;\r\n    transition: all 0.3s ease;\r\n    font-weight: 200;\r\n    font-size: 1.1rem;\r\n    overflow: hidden;\r\n}\r\n\r\n.fixed-return-button:hover {\r\n    border-radius: 50px;\r\n    padding: 8px 25px;\r\n    background-color: var(--primary-blue);\r\n    gap: 10px;\r\n}\r\n\r\n.fixed-return-button:hover .return-text-hover {\r\n    opacity: 1;\r\n    max-width: 200px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
